<template>
  <div>
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>招接待宾馆预约系统</el-breadcrumb-item>
        <el-breadcrumb-item>宾馆房间管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item style="margin-bottom:0">
              <el-button
                size="small"
                type="primary"
                @click="add"
                style="margin-bottom:0"
              >
                新增
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <hx-table-result
      :page-info="pager"
      :loading="tableLoading"
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange"
    >
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px;">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column prop="pictures" align="center" label="房间图片">
          <template slot-scope="scope">
            <div class="commodity-name-style">
              <div class="commodity-wrap-img-style">
                <img
                  :src="scope.row.pictures[0]"
                  alt=""
                  class="commodity-img-style"
                  style="width:100%"
                />
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="name" align="center" label="房间名称">
        </el-table-column>

        <el-table-column prop="type" align="center" label="房间类型">
        </el-table-column>

        <el-table-column prop="area" align="center" label="房间大小">
          <template slot-scope="scope"> {{ scope.row.area }}㎡ </template>
        </el-table-column>

        <el-table-column prop="bed" align="center" label="床型">
          <template slot-scope="scope">
            <div v-for="i in scope.row.bed" :key="i">
              <span>{{ i.num }}张 {{ i.size }}米</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="price" align="center" label="房价(¥)">
        </el-table-column>

        <el-table-column prop="applyDate" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="detailItem(scope.row.id)"
              >编辑</el-button
            >
            <confirm-button
              type="text"
              style="margin: 0 10px;"
              title="确认要删除该条数据？"
              v-on:confirmed="deleteItem(scope.row.id)"
            >
              <span>删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {},
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0
      }
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    deleteItem: function(id) {
      this.tableLoading = true;
      const bodyParams = Object.assign({}, this.listParams, {
        roomId: id
      });
      this.$http({
        url: global.apiUrl + "/reception/hotel/room/delete",
        method: "POST",
        body: bodyParams,
        emulateJSON: true
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {

            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    detailItem: function(id) {
      this.$router.push({
        name: "roomManageDetail",
        query: {
          roomId: id
        }
      });
    },
    add: function() {
      this.$router.push({
        name: "roomManageAdd"
      });
    },
    loadTableData() {
      this.tableLoading = true;
      const bodyParams = Object.assign({}, this.listParams, {
        page: this.pager.pageIndex,
        size: this.pager.pageSize
      });
      this.$http({
        url: global.apiUrl + "/reception/hotel/room/list",
        method: "GET",
        params: bodyParams
      })
        .then(res => {
          const that = this;
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data && res.body.data.data.length > 0) {
              this.tableData = res.body.data.data;
              this.pager.total = res.body.data.total;
              this.tableData.forEach(function(value, index) {
                // eslint-disable-next-line no-eval
                that.tableData[index].bed = eval("(" + value.bed + ")");
              });
            } else {
              this.tableData = [];
            }
          } else {

            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 重置表单
     * @param name
     */
    resetForm(name) {
      this.$refs[name].resetFields();
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    }
  }
};
</script>
<style>
#convalescenceInfoTable {
  width: 100%;
}
#convalescenceInfoTable th {
  font-weight: normal;
  text-align: left;
  font-size: 14px;
}
#convalescenceInfoTable td {
  font-size: 14px;
}
</style>
